// extracted by mini-css-extract-plugin
export var actionButton = "_d1-t";
export var buttonContainer = "_d1-0";
export var buttonContainer2 = "_d1-1";
export var buttonSection = "_d1-2";
export var details = "_d1-3";
export var dropdownItem = "_d1-5";
export var dropdownItemsContainer = "_d1-4";
export var fileInput = "_d1-r";
export var headerButton = "_d1-6";
export var icon = "_d1-7";
export var input = "_d1-8";
export var macroListItem = "_d1-9";
export var mainContent = "_d1-a";
export var microText = "_d1-b";
export var modal = "_d1-w";
export var optionsButton = "_d1-c";
export var paperclip = "_d1-s";
export var pillContent = "_d1-d";
export var preview = "_d1-e";
export var preview2 = "_d1-f";
export var quillEditor = "_d1-q";
export var selectedMacro = "_d1-g";
export var sidebar = "_d1-h";
export var sidebarHeader = "_d1-j";
export var sidebarList = "_d1-i";
export var sidebarListItem = "_d1-k";
export var sidebarSearch = "_d1-l";
export var snoozeDurationWrapper = "_d1-v";
export var statusPillContainer = "_d1-m";
export var tagsContainer = "_d1-n";
export var unselectedMacro = "_d1-o";
export var variable = "_d1-u";
export var wrapper = "_d1-p";